import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import classNames from 'classnames'

import Modal from '../common/Modal'
import CancelButton from '../common/buttons/CancelButton'
import SubmitButton from '../common/buttons/SubmitButton'
import AddFamilyMemberModal from '../classes/ProgramRegistration/ProgramDetailsStep/AddFamilyMemberModal'
import { ReactComponent as ClapIcon } from '../../assets/images/common/icons/clap-icon.svg'
import { addFamilyMember, inviteFamilyMember } from '../../actions/familyActions'
import { serialize } from '../../utility/serialization'
import { hasSeenWelcome, isFirstLogin, markWelcomeSeen } from '../../utility/welcomeModal'

import classes from './StudentWelcomeModal.module.scss'

const StudentWelcomeModal = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const user = useSelector(state => state.user.current_user)

  const [showWelcome, setShowWelcome] = useState(() => !!user.account_segment && isFirstLogin(user) && !hasSeenWelcome(user.id))
  const [showAddFamilyMember, setShowAddFamilyMember] = useState(false)
  const [loader, setLoader] = useState(false)

  const handleGoToDashboard = () => {
    markWelcomeSeen(user.id)
    setShowWelcome(false)
  }

  const handleOpenAddFamilyMember = () => {
    markWelcomeSeen(user.id)
    setShowWelcome(false)
    setShowAddFamilyMember(true)
  }

  const handleCreateFamilyMember = (userData) => {
    const userFormData = { ...userData, avatar_attributes: userData.avatar ? { photo: userData.avatar, name: userData.avatar.name } : null }
    const submit = userData.email
      ? dispatch(inviteFamilyMember(serialize(userFormData)))
      : dispatch(addFamilyMember(serialize(userFormData)))

    setLoader(true)
    return submit
      .then(() => {
        setShowAddFamilyMember(false)
        navigate('/dashboard/account')
      })
      .finally(() => setLoader(false))
  }

  return (
    <>
      <Modal isOpen={showWelcome} onClose={handleGoToDashboard} className={classes.welcomeModalContent}>
        <div className={classNames(classes.welcomeModal, 'd-flex flex-column align-items-center text-center')}>
          <div className={classNames(classes.iconCircle, 'd-flex align-items-center justify-content-center')}>
            <ClapIcon className={classes.clapIcon} aria-hidden='true' />
          </div>

          <h2 className={classNames(classes.modalTitle, 'mt-4 mb-2')}>{t('auth.accountSegmentWelcome.title')}</h2>
          <p className={classNames(classes.modalSubtitle, 'mb-5')}>
            {t('auth.accountSegmentWelcome.subtitle')}
          </p>

          <div className='row w-100'>
            <div className='col-6'>
              <SubmitButton
                type='button'
                buttonMessage={t('auth.accountSegmentWelcome.addFamilyMember')}
                onClick={handleOpenAddFamilyMember}
                noTopMargin
              />
            </div>

            <div className='col-6'>
              <CancelButton onClick={handleGoToDashboard} buttonMessage={t('auth.accountSegmentWelcome.goToDashboard')} />
            </div>
          </div>
        </div>
      </Modal>

      <AddFamilyMemberModal
        isOpen={showAddFamilyMember}
        onClose={() => setShowAddFamilyMember(false)}
        handleCreate={handleCreateFamilyMember}
        loader={loader}
      />
    </>
  )
}

export default StudentWelcomeModal
